import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { InitialTouchPoint } from '../api/models';
import { State } from '../store/interfaces';
import {
  loadInitialTouchPointErrorAction,
  loadInitialTouchPointRequestAction,
  loadInitialTouchPointSuccessAction,
} from '../store/reducers/initialTouchPoint';
import { StatusCodes } from 'http-status-codes';
import { InitialTouchPointService } from '../api';

export const useInitialTouchPoint = (
  initialTouchPointService: InitialTouchPointService
) => {
  const intent = useSelector((state: State) => state.initialTouchPoint);

  const [updating, setUpdating] = useState<boolean>(false);
  const [updateError, setUpdateError] = useState<string | undefined>();
  const dispatch = useDispatch();

  const loadInitialTouchPoint = async () => {
    if (intent.isLoading || intent.isLoaded) {
      return;
    }
    dispatch(loadInitialTouchPointRequestAction());
    try {
      const response = await initialTouchPointService.loadAllInitialTouchPoint();

      return dispatch(loadInitialTouchPointSuccessAction(response));
    } catch (error) {
      return dispatch(loadInitialTouchPointErrorAction());
    }
  };

  const createInitialTouchPoint = async (
    data: InitialTouchPoint,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await initialTouchPointService.createInitialTouchPoint({
        ...data,
      });
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  const updateInitialTouchPoint = async (
    data: InitialTouchPoint,
    id?: string,
    onSuccess?: () => void
  ) => {
    setUpdateError(undefined);
    setUpdating(true);
    try {
      const response = await initialTouchPointService.updateInitialTouchPoint(
        {
          ...data,
        },
        id
      );
      if (response.status === StatusCodes.OK) {
        if (onSuccess) onSuccess();
      } else {
        setUpdateError('Unable to update details');
      }
    } catch (error) {
      setUpdateError('Unable to update details');
    }
    setUpdating(false);
  };

  return {
    loadInitialTouchPoint,
    createInitialTouchPoint,
    updateInitialTouchPoint,
    updating,
    updateError,
  };
};
